import script from "./RadiogroupRadio.vue?vue&type=script&lang=js"
export * from "./RadiogroupRadio.vue?vue&type=script&lang=js"

import "./RadiogroupRadio.vue?vue&type=style&index=0&id=b323786a&lang=scss"

const __exports__ = script;

export default __exports__